 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import GROVEATLANTICLITHUB from '@/components/grove-atlantic-lithub'
 import LOVE_1 from '@/components/love_1'
 import A780802159038 from '@/components/9780802159038'
 import A7808021590381 from '@/components/9780802159038-1'
 import A7808021590382 from '@/components/9780802159038-2'
 import A7808021590383 from '@/components/9780802159038-3'
 import A7808021590384 from '@/components/9780802159038-4'
 import A7808021590385 from '@/components/9780802159038-5'
 import A7808021590386 from '@/components/9780802159038-6'
 import A7808021590387 from '@/components/9780802159038-7'
 import A7808021590388 from '@/components/9780802159038-8'
 import A7808021590389 from '@/components/9780802159038-9'
 import A78080215903810 from '@/components/9780802159038-10'
 import A78080215903811 from '@/components/9780802159038-11'
 import A78080215903812 from '@/components/9780802159038-12'
 import A78080215903813 from '@/components/9780802159038-13'
 import A78080215903814 from '@/components/9780802159038-14'
 import A78080215903815 from '@/components/9780802159038-15'
 import A78080215903816 from '@/components/9780802159038-16'
 import A78080215903817 from '@/components/9780802159038-17'
 import A78080215903818 from '@/components/9780802159038-18'
 import A78080215903819 from '@/components/9780802159038-19'
 import A78080215903820 from '@/components/9780802159038-20'
 import A78080215903821 from '@/components/9780802159038-21'
 import A78080215903822 from '@/components/9780802159038-22'
 import A78080215903823 from '@/components/9780802159038-23'
 import A78080215903824 from '@/components/9780802159038-24'
 import A78080215903825 from '@/components/9780802159038-25'
 import A78080215903826 from '@/components/9780802159038-26'
 import A78080215903827 from '@/components/9780802159038-27'
 import A78080215903828 from '@/components/9780802159038-28'
 import A78080215903829 from '@/components/9780802159038-29'
 import A78080215903830 from '@/components/9780802159038-30'
 import A78080215903831 from '@/components/9780802159038-31'
 import A78080215903832 from '@/components/9780802159038-32'
 import A78080215903833 from '@/components/9780802159038-33'
 import A78080215903834 from '@/components/9780802159038-34'
 import A78080215903835 from '@/components/9780802159038-35'
 import A78080215903836 from '@/components/9780802159038-36'
 import A78080215903837 from '@/components/9780802159038-37'
 import A78080215903838 from '@/components/9780802159038-38'
 import A78080215903839 from '@/components/9780802159038-39'
 import A78080215903840 from '@/components/9780802159038-40'
 import A78080215903841 from '@/components/9780802159038-41'
 import A78080215903842 from '@/components/9780802159038-42'
 import A78080215903843 from '@/components/9780802159038-43'
 import A78080215903844 from '@/components/9780802159038-44'
 import A78080215903845 from '@/components/9780802159038-45'
 import A78080215903846 from '@/components/9780802159038-46'
 import A78080215903847 from '@/components/9780802159038-47'
 import A78080215903848 from '@/components/9780802159038-48'
 import A78080215903849 from '@/components/9780802159038-49'
 import A78080215903850 from '@/components/9780802159038-50'
 import A78080215903851 from '@/components/9780802159038-51'
 import A78080215903852 from '@/components/9780802159038-52'
 import A78080215903853 from '@/components/9780802159038-53'
 import A78080215903854 from '@/components/9780802159038-54'
 import A78080215903855 from '@/components/9780802159038-55'
 import A78080215903856 from '@/components/9780802159038-56'
 import A78080215903857 from '@/components/9780802159038-57'
 import A78080215903858 from '@/components/9780802159038-58'
 import A78080215903859 from '@/components/9780802159038-59'
 import A78080215903860 from '@/components/9780802159038-60'
 import A78080215903861 from '@/components/9780802159038-61'
 import A78080215903862 from '@/components/9780802159038-62'
 import LOVE_2 from '@/components/love_2'
 import A78080215903863 from '@/components/9780802159038-63'
 import A78080215903864 from '@/components/9780802159038-64'
 import A78080215903865 from '@/components/9780802159038-65'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/grove-atlantic-lithub",
 			"name" : "grove-atlantic-lithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/9780802159038",
 			"name" : "9780802159038",
 			"component" : A780802159038
 		},
 		{
 			"path" : "/9780802159038-1",
 			"name" : "9780802159038-1",
 			"component" : A7808021590381
 		},
 		{
 			"path" : "/9780802159038-2",
 			"name" : "9780802159038-2",
 			"component" : A7808021590382
 		},
 		{
 			"path" : "/9780802159038-3",
 			"name" : "9780802159038-3",
 			"component" : A7808021590383
 		},
 		{
 			"path" : "/9780802159038-4",
 			"name" : "9780802159038-4",
 			"component" : A7808021590384
 		},
 		{
 			"path" : "/9780802159038-5",
 			"name" : "9780802159038-5",
 			"component" : A7808021590385
 		},
 		{
 			"path" : "/9780802159038-6",
 			"name" : "9780802159038-6",
 			"component" : A7808021590386
 		},
 		{
 			"path" : "/9780802159038-7",
 			"name" : "9780802159038-7",
 			"component" : A7808021590387
 		},
 		{
 			"path" : "/9780802159038-8",
 			"name" : "9780802159038-8",
 			"component" : A7808021590388
 		},
 		{
 			"path" : "/9780802159038-9",
 			"name" : "9780802159038-9",
 			"component" : A7808021590389
 		},
 		{
 			"path" : "/9780802159038-10",
 			"name" : "9780802159038-10",
 			"component" : A78080215903810
 		},
 		{
 			"path" : "/9780802159038-11",
 			"name" : "9780802159038-11",
 			"component" : A78080215903811
 		},
 		{
 			"path" : "/9780802159038-12",
 			"name" : "9780802159038-12",
 			"component" : A78080215903812
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js